"use client";

import { BookOpen, Coffee, CloudRain, Leaf, SunMedium, Droplets } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NuestrosPilaresTicos() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const amenities = [{
    icon: Leaf,
    label: "INTEGRIDAD",
    title: "Ética Profesional",
    description: "Actuamos con rectitud y transparencia en cada protocolo de seguridad."
  }, {
    icon: CloudRain,
    label: "VIGILANCIA",
    title: "Protección 24/7",
    description: "Monitoreo constante y respuesta inmediata ante cualquier eventualidad."
  }, {
    icon: Coffee,
    label: "DISCIPLINA",
    title: "Formación Élite",
    description: "Personal capacitado bajo los más altos estándares de rigor corporativo."
  }, {
    icon: Droplets,
    label: "TECNOLOGÍA",
    title: "Sistemas Avanzados",
    description: "Integración de herramientas digitales para una seguridad inteligente."
  }, {
    icon: BookOpen,
    label: "LEGALIDAD",
    title: "Cumplimiento Normativo",
    description: "Operamos bajo estrictos permisos y regulaciones nacionales vigentes."
  }, {
    icon: SunMedium,
    label: "CONFIANZA",
    title: "Lealtad Absoluta",
    description: "Compromiso inquebrantable con la tranquilidad de nuestros clientes."
  }];
  return <section data-section-id="77" id="nuestros-pilares-éticos" className="relative overflow-hidden bg-background text-foreground py-24 md:py-40">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: "repeating-radial-gradient(circle at 20% 30%, hsl(45 100% 52%) 0px, transparent 1px, transparent 60px), repeating-radial-gradient(circle at 80% 70%, hsl(45 100% 52%) 0px, transparent 1px, transparent 80px)"
    }} />

      <div ref={ref} className={`relative max-w-6xl mx-auto px-6 md:px-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div className="text-center max-w-3xl mx-auto mb-20 md:mb-28">
          <p className="font-mono text-xs tracking-[0.3em] text-primary-foreground mb-6">
            § 02 / VALORES CORPORATIVOS
          </p>
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] text-foreground">
            Nuestros pilares,
            <br />
            <span className="italic font-serif font-light">estratégicamente sólidos.</span>
          </h2>
          <div className="mt-10 mx-auto h-px w-16 bg-primary-foreground/60" />
        </div>

        {}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-px bg-border/20">
          {amenities.map((amenity, i) => {
          const Icon = amenity.icon;
          return <div key={i} data-index={i} className="group relative bg-card px-6 py-12 md:px-10 md:py-16 flex flex-col items-center text-center transition-colors duration-300 hover:bg-accent/5">
                <Icon strokeWidth={1.25} className="h-12 w-12 text-foreground transition-colors duration-[400ms] ease-out group-hover:text-primary-foreground" aria-hidden="true" />
                <p className="mt-8 font-mono text-[0.65rem] md:text-xs tracking-[0.3em] text-primary-foreground">
                  {amenity.label}
                </p>
                <h3 className="mt-3 font-default text-lg md:text-xl font-semibold text-foreground">
                  {amenity.title}
                </h3>
                <p className="mt-4 font-default text-sm md:text-base leading-relaxed text-muted-foreground max-w-[26ch]">
                  {amenity.description}
                </p>
                {}
                <div className="absolute top-0 left-0 w-1 h-1 border-t border-l border-primary-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="absolute top-0 right-0 w-1 h-1 border-t border-r border-primary-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="absolute bottom-0 left-0 w-1 h-1 border-b border-l border-primary-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="absolute bottom-0 right-0 w-1 h-1 border-b border-r border-primary-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>;
        })}
        </div>

        {}
        <div className="mt-20 md:mt-28 flex flex-col items-center">
          <div className="h-px w-16 bg-primary-foreground/60" />
          <p className="mt-6 font-mono text-[0.65rem] tracking-[0.3em] text-muted-foreground">
            GRUPO POSEIDÓN &middot; PROTECCIÓN DE ÉLITE
          </p>
        </div>
      </div>
    </section>;
}